<template>
  <div>
    <AppRow
      v-if="def.sideSectionFields"
      class="top-section mb-1"
    >
      <ul style="padding-left : 0px">
        <li 
          v-for="ss in def.sideSectionFields"
          :key="ss.id"
          class="top-section-li"
        >
          <label class="top-section-label py-2"> {{ $t(ss) }}</label>
          <p class="top-section-value">
            {{ displayValue(ss , model[ss.name]) }}
          </p>
        </li>
      </ul>
    </AppRow>
    <AppList
      :class="[(def.sideSectionFields && 'side-section-overflow')]"
      style="padding-left : 12px"
    >
      <AppListItemGroup
        v-model="selected"
        color="S1"
      >
        <AppListItem
          v-for="(section, index) in def.sections"
          v-show="sectionsVisible[index]"
          :id="section.id"
          :key="index"
          dir="rtl"
          :class="sectionsVisible[index] && `${def.name}-side-menu-form`"
          class="sideBar"
          link
          @click.stop="scroll(section.id, index)"
        >
          <template #content>
            {{ $t(section) }}
          </template>
        </AppListItem>
      </AppListItemGroup>
    </AppList>
  </div>
</template>

<script>
import AppList from "@/components/library/list/AppList";
import AppListItem from "@/components/library/list/AppListItem";
import AppListItemGroup from "@/components/library/list/AppListItemGroup";
import AppRow from "@/components/library/container/AppRow";
import AbrPropDisplayValue from "@/mixins/AbrPropDisplayValue"


export default {
  name: "AbrFormPageSideSection",
  components: {
    AppListItemGroup,
    AppListItem,
    AppList,
    AppRow
  },
  mixins : [AbrPropDisplayValue],
  props: ["def" , "model"],
  data: () => ({
    canScroll: true,
    clear: null,
    selected: 0,
    sectionsVisible: []
  }),
  async created(){
    this.sectionsVisible = await Promise.all(this.def.sections?.map(sec => this.$checkVisibility(sec)) || []);
    this.$eventBus.$on(`${this.def.id}-SideSectionScrollPos`, payload => {
      if(!this.canScroll) return;
      this.selected = payload;
    })
  },
  beforeDestroy(){
    this.$eventBus.$off(`${this.def.id}-SideSectionScrollPos`)
  },
  methods: {
    scroll(section, index) {
        this.canScroll = false;
        const menus = document.querySelectorAll(`.${this.def.id}-side-menu-form`);
        const timeout = (Math.abs(this.selected - (index)) * 500);
        menus.forEach((m, index) => {
        if (m.id === section)
            this.selected = index;
        });
        this.$eventBus.$emit("PageScrollToPos" , section);
        if (this.clear) clearTimeout(this.clear);
        this.clear = setTimeout(() => {
        this.canScroll = true;
        }, timeout);
    }
  }
};
</script>
<style>
.section1{
  border-top: solid 1px rgba(224, 224, 224, 1);
  border-radius: 0;
  border-collapse: collapse;
}

.section1:first-child{
  border-top:none;
}


.page_height{
  height: 74.5vh
}

.page_height_with_tabs{
  height: 70.5vh
}
.top-section{
  background-color: #F5F6FA;
}

.top-section-label{
  display: block;
  padding : 5px 0;
  font-size: 10px;
  /*line-height: 21px;*/
  color: #757575;
}
.top-section-value{
  font-size: 12px;
  /*line-height: 24px;*/
  text-align: right;
}
.top-section-li {
  width: 200%;
  padding : 0px 16px;
  border-bottom: 1px solid #E0E0E0;
  height: 58px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}
.side-section-overflow{
  max-height: 34vh;
  overflow: scroll;
  padding-left: 3px !important;
}
.v-list-item__content{
  color: black;
}

/*  DARK MODE  */

.theme--dark .top-section {
  background-color: #2D2D2D !important; /* BG1 */
}

.theme--dark .top-section-label {
  color: #AFAFAF !important; /* G3 */
}

.theme--dark .top-section-value {
  color: #FFFFFF !important; /* G1 */
}

.theme--dark .top-section-li {
  border-bottom: 1px solid #424242 !important; /* G4 */
}

.theme--dark .v-list-item__content {
  color: #FFFFFF !important; /* G1 */
}

.theme--dark .sideBar.v-list-item--active {
  background-color: rgba(41, 105, 227, 0.25) !important; /* P1 tinted */
}

.theme--dark .sideBar.v-list-item--active .v-list-item__content {
  color: #2969E3 !important; /* P1 اصلی */
}


</style>
